import { mainMenu, dropdownMenu } from "./menu";
import headerInit from "./header";
import { ready } from "./utils";
import { formEntry } from "./form_entry";
// import { tocAnchor } from './toc';
// import { sentNewMessage } from './thank-you-messages';
import { gclid } from "./gclid";
import { readMore, loadMore, showMorePrograms, loadMoreReview } from "./show-more";
import { modalDialog } from "./modals";
import { cf7RedirectsAfterSubmit } from "./cf7-redirects-after-submit";
import { groverSliders } from "./sliders";
import { AttorneyInfoTabs } from "./attorney-info-tabs";
import { reviewRate } from "./review-rate";
import { videoScroll } from "./autoplay-video";

ready(() => {
  mainMenu();
  dropdownMenu();
  headerInit();
  formEntry();
  // sentNewMessage('.sidebar-form');
  gclid();
  readMore();
  loadMore();
  cf7RedirectsAfterSubmit();
  groverSliders();
  modalDialog();
  AttorneyInfoTabs();
  reviewRate();
  loadMoreReview();
  videoScroll();
});
